/**
 * Detects a dynamic-import / chunk-load failure across Angular 18 + native
 * dynamic-import shapes. Returns false for ordinary HttpErrorResponse 5xx
 * against /api/... so a backend outage does NOT trigger an auto-reload.
 *
 * Recognised shapes:
 *   - legacy webpack:  "Loading chunk 12 failed"
 *   - native esm:      "Failed to fetch dynamically imported module: <url>"
 *   - Angular CLI:     error.name === 'ChunkLoadError'
 */

const CHUNK_LOAD_PATTERNS: ReadonlyArray<RegExp> = [
  /Loading chunk [\d]+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
];

export function isDynamicImportFailure(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const err = error as { name?: unknown; message?: unknown; url?: unknown };

  if (typeof err.name === 'string' && err.name === 'ChunkLoadError') {
    return true;
  }

  if (typeof err.message === 'string') {
    for (const pattern of CHUNK_LOAD_PATTERNS) {
      if (pattern.test(err.message)) {
        return true;
      }
    }
  }

  return false;
}
